import React from "react";
import { ContentBlock } from "../../../types";
import ContentBlockRenderer from "./ContentBlockRenderer";

type Props = {
    contentBlocks: ContentBlock[];
    paddingY?: string;
};

const ContentArticleReader = ({ contentBlocks, paddingY = '30px' }: Props) => {
    if (!contentBlocks?.length) return null;

    const sortedBlocks = [...contentBlocks].sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0)
    );

    return (
        <>
            {sortedBlocks.map((block) => (
                <ContentBlockRenderer key={block.id} block={block} paddingY={paddingY} />
            ))}
        </>
    );
};

export default ContentArticleReader;
